(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSaariVideos() {
      var vids = document.querySelectorAll('video.saari-video__media');
      if (!vids.length) return;
      vids.forEach(function (v) {
        v.muted = true;
        v.defaultMuted = true;
        v.removeAttribute('controls');
        if (v.dataset.saariBound) return;
        v.dataset.saariBound = '1';
        v.addEventListener('contextmenu', function (e) { e.preventDefault(); });
        v.addEventListener('volumechange', function () { if (!v.muted) v.muted = true; });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                v.preload = 'auto';
                var p = v.play();
                if (p && p.catch) p.catch(function () {});
              } else {
                v.pause();
              }
            });
          }, { rootMargin: '200px 0px', threshold: 0.01 }).observe(v);
        } else {
          v.play().catch(function () {});
        }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSaariVideos);
    else initSaariVideos();
    document.addEventListener('shopify:section:load', initSaariVideos);
    document.addEventListener('shopify:block:select', initSaariVideos);
  })();
  } catch(e) { console.error(e); }
})();

})();
